export default "<ion-content>\n<router-outlet></router-outlet>\n</ion-content>"